import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceAnalyticsAction from '../actions/ecommerce-analytics.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceAnalytics} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import * as fromStore from "../../store";

@Injectable()
export class EcommerceAnalyticsEffect {

  loadEcommerceAnalytics = createEffect(() => this._actions$.pipe(
    ofType(EcommerceAnalyticsAction.LOAD_ECOMMERCE_ANALYTICS),
    mergeMap((action: LoadEcommerceAnalytics) => {
      const {websiteId} = action.payload;
      const datePicker = action?.payload?.datePicker;
      return this._ecommerceService.getAnalyticsData(websiteId, datePicker)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommerceAnalyticsAction.LoadEcommerceAnalyticsSuccess({
                data: response?.data?.dataKey,
                websiteId: websiteId,
                loaded: true
              });
            }
            else {
                // Convert the string into a URLSearchParams object
                const params = new URLSearchParams(datePicker);

                const afterCurrent = params.get('after_current');
                const beforeCurrent = params.get('before_current');
                const afterPrevious = params.get('after_previous');
                const beforePrevious = params.get('before_previous');

                const cutomDateRangePrevious = '&after=' + afterPrevious + '&before=' + beforePrevious;
                const cutomDateRangeCurrent = '&after=' + afterCurrent + '&before=' + beforeCurrent;

                this._store.dispatch(new fromStore.LoadEcommercePerformanceNow({websiteId: websiteId, datePicker: cutomDateRangeCurrent}));
                this._store.dispatch(new fromStore.LoadEcommercePerformanceReportOrders({websiteId: websiteId, datePicker: cutomDateRangeCurrent}));
                this._store.dispatch(new fromStore.LoadEcommercePerformanceReportNetSales({websiteId: websiteId, datePicker: cutomDateRangeCurrent}));

                this._store.dispatch(new fromStore.LoadEcommercePerformance({websiteId: websiteId, datePicker: cutomDateRangePrevious}));
                this._store.dispatch(new fromStore.LoadEcommercePerformanceReportOrdersLastYear({websiteId: websiteId, datePicker: cutomDateRangePrevious}));
                this._store.dispatch(new fromStore.LoadEcommercePerformanceReportNetSalesLastYear({websiteId: websiteId, datePicker: cutomDateRangePrevious}));

            }
            return new EcommerceAnalyticsAction.LoadEcommerceAnalyticsFail({websiteId});
          })
        );
    })
  ));


  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
